
 export enum EOTPUseCases {
  INDIVIDUAL_SIGNUP = 'individual_signup',
  ORG_SIGNUP = 'org_signup',
  SIGN_IN = 'sign-in',
  DONATION = 'donation',
  WITHDRAWAL= 'withdrawal'
}